export { ZorroLoaderV2 as Loader } from './Loader';
